import React, { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState({}); // Store theme details

  const applyTheme = (themeData) => {
    Object.keys(themeData).forEach((key) => {
      document.documentElement.style.setProperty(`--${key}`, themeData[key]);
    });
  };

  useEffect(() => {
    if (Object.keys(theme).length > 0) {
      applyTheme(theme);
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
